import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceDeliveryNoteListItem } from "@msuite/utils/types";

/** Props Interface */
interface DeliveryNoteNumberCellProps {
	deliveryNote: IncomingInvoiceDeliveryNoteListItem;
}

/** The delivery note's own number, or a tag saying it could not be read. */
export function DeliveryNoteNumberCell({ deliveryNote }: DeliveryNoteNumberCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	if (deliveryNote.extractionState !== "failed") return guardString(deliveryNote.number);
	return (
		<Tag
			size="xs"
			color="gray"
			variant="plain"
		>
			{t("incoming_invoices.extraction_failed")}
		</Tag>
	);
}
